
<div class="create-dialog-box scrollable-dialog">
    <div class="title d-flex align-items-center justify-content-space-between sticky-header">
        <h4 class="mb-0">Add Comment</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i
                class="flaticon-close"></i></button>
    </div>
    <mat-card class="tagus-card add-user-wrapper">
        <mat-card-content>
            <form [formGroup]="comment_form">
                <div class="row">
                    <div class="col-lg-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label class="form-label">
                                Comment
                            </mat-label>
                            <textarea matInput class="form-control" formControlName="textCommend" 
                            style="height: 130px;"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="text-end">
                        <button mat-raised-button color="warn" (click)="updatedFineList()">Add Comment</button>
                    </div>    
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div> 